<template>
  <label :class="$style.base">
    <slot />
  </label>
</template>

<style module>
.base {
  position: absolute;
  left: 12px;
  top: 5px;
  color: var(--color-blackcoral);
  font-size: clamp(12px, 2vw, 14px);
  line-height: clamp(22px, 2vw, 24px);
  opacity: 0.5;
  transition: var(--transition-default);
    input:focus + &, textarea:focus + & {
      opacity: 0.8;
    }
    input:disabled + & {
      color: var(--color-jet-20);
    }
    input:not(input[type="checkbox"]):read-only {
      color: rga(var(--color-jet) / 0.2);
    }
}
</style>
